// extracted by mini-css-extract-plugin
module.exports = {"form":"DistributionForm_form__1PGuU"};